import { TCurrentRegion } from '../../types/currentRegion';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ECurrentRegionActions {
  Set = 'CURRENT_REGION/SET',
}

export type TSetCurrentRegion = ITypedReduxAction<ECurrentRegionActions.Set, TCurrentRegion>;

export const setCurrentRegion = actionGenerator<ECurrentRegionActions.Set, TCurrentRegion>(ECurrentRegionActions.Set);

export type TCurrentRegionsActions = TSetCurrentRegion;
